<div mat-dialog-container>
  <div class="mat-dialog-header-content">
    <mat-icon class="{{'icon ' + data.messageType + '-icon'}}">{{icons[data.messageType].icon}}</mat-icon>
  </div>
  <div class="mat-dialog-header-content">
    <h1>{{data.messageTitle}}</h1>
  </div>

  <mat-dialog-content *ngIf="TitleforSchool()">
    <mat-card class="form-section mat-elevation-z0">
      <form [formGroup]="copyActivityForm">
        <mat-form-field appearance="outline" class="mat-dialog-content">
          <mat-label>{{'ACTIVITIES.ACT_COPY.EMAIL'|translate}}</mat-label>
          <input type="text" placeholder="Escribe el Correo" aria-label="Email" matInput formControlName="email"
            [matAutocomplete]="auto">
            <mat-hint *ngIf="true">Campo Obligatorio</mat-hint>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let userTeacher of userTeachers" [value]="userTeacher.email">
              {{userTeacher.name}} {{userTeacher.email}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="!TitleforSchool()">
    <form [formGroup]="copyActivityForm" #lessonCreator>
      <mat-card class="form-section mat-elevation-z0">
        <mat-card-content fxLayout="column">
          <mat-form-field appearance="outline" class="input-form-field">
            <mat-label>{{'ACTIVITIES.ACT_COPY.EMAIL'|translate}}</mat-label>
            <input matInput formControlName="email" placeholder="Correo Electrónico" required>
            <mat-hint *ngIf="true">Campo Obligatorio</mat-hint>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </form>
  </mat-dialog-content>

  <div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [mat-dialog-close]="copyActivityForm.get('email').value"
      cdkFocusInitial>Aceptar</button>
    <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="accent"
      [mat-dialog-close]="false" (click)="closeMe()">Cancelar</button>
    <button mat-flat-button *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'" color="primary"
      [mat-dialog-close]="true" (click)="closeMe()">Cerrar</button>
  </div>
</div>